import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserReportType } from 'src/app/shared/constants/user-report-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { PostProfileDetailsComponent } from '../../../shared/components/post-profile-details/post-profile-details.component';

import { SharedService } from '../../../providers/shared.service';
import { BlockedAccountsDetailsComponent } from '../../../shared/components/blocked-accounts-details/blocked-accounts-details.component';

@Component({
  selector: 'sm-linked-qr',
  templateUrl: './linked-qr.component.html',
  styleUrls: ['./linked-qr.component.scss']
})
export class LinkedQRComponent implements OnInit {

  accountList: any[] = [];
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "business",
      columnProperty: "name"
    },
    {
      columnName: "Qr Id",
      columnProperty: "qr_code"
    },
   
    {
      columnName: "shop/ Home",
      columnProperty: "booking_type"
    },
    {
      columnName: "date",
      columnProperty: "creation_time"
    }
    
  ];
  private _apiSub: Subscription;
  clickEventSubscription: Subscription;
  constructor(private _apiService : ApiService,  private _datePipe: DatePipe, private _dialog: MatDialog,
    private sharedService: SharedService) { 

      this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
        this.ngOnInit();
      })
      
    this._apiSub = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_LINKED_QR_CODES_RESULT){
        console.log(resData);
      
        this.accountList = resData.result ? resData.result : [];
        this.accountList.forEach((item )=> {
        
          if(item.booking_type == '0'){
            item.booking_type = 'Home'
          }
          else if(item.booking_type == '1'){
            item.booking_type = 'Shop'
          }
         
        })
        this.accountList =     this.accountList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creation_time'])) - (+new 
        Date(dataA['creation_time'])))
 
     )
   
        this.accountList.map(account => {
          account.creation_time = this._datePipe.transform(account.creation_time, 'MMM d, y');
          
        });
      }
      this.loader = false
    });
  }

  ngOnInit(): void {
    this.loader = true
    this._apiService.getLinkedQRCodes()
  }

  ngOnDestroy(){
    this._apiSub.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

  viewProfile(rowvalue:any){
    console.log(rowvalue);
    rowvalue.requestTypeInfo = null
    this._dialog.open(BlockedAccountsDetailsComponent, {
      data: rowvalue,
      width: '500px',
      panelClass: 'user-profile-dialog'
    });
    
  }

  unblock(value: any){
    console.log(value);

  
      
     
      // this._dialog.open(UnblockAccountsComponent, {
      //   height: '350px',
      //   disableClose: true,
      //   data: {
      //     ref: this._dialog,
      //     data: value
      //   }
      // });
  

   
  }

}
